import React from 'react';
import { Navigate } from 'react-router-dom';

const Register = () => <Navigate to="/login" replace />;

export default Register;
